import Route from '@ember/routing/route';
import { service } from '@ember/service';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { SNAPSHOT_PATHS } from 'lumen/utils/spider';

@protectedRoute({ features: ['spider.hotel_snapshot'] })
export default class HotelSnapshotIndexRoute extends Route {
  @service router;

  redirect() {
    this.router.replaceWith(
      'hotel.snapshot.spider-dashboard',
      SNAPSHOT_PATHS[0],
    );
  }
}
